// Firebase Web Polyfill
// Este archivo proporciona implementaciones simuladas de funcionalidades nativas de Firebase para entorno web

// Clase de servicio de Analytics
class AnalyticsService {
  async setAnalyticsCollectionEnabled(enabled) {
    console.log('Analytics collection set to:', enabled);
    return Promise.resolve();
  }

  async getAppInstanceId() {
    console.log('Getting app instance ID (web polyfill)');
    return 'web-app-instance-id';
  }

  async logEvent(eventName, params) {
    console.log(`[Analytics] Event: ${eventName}`, params || {});
    return Promise.resolve();
  }

  async setUserId(userId) {
    console.log(`[Analytics] Set user ID: ${userId}`);
    return Promise.resolve();
  }

  async setUserProperty(name, value) {
    console.log(`[Analytics] Set user property: ${name} = ${value}`);
    return Promise.resolve();
  }

  async logScreenView(screenName, screenClass) {
    console.log(`[Analytics] Screen view: ${screenName} (${screenClass || screenName})`);
    return Promise.resolve();
  }

  async setConsent(settings) {
    console.log('[Analytics] Set consent:', settings);
    return Promise.resolve();
  }

  async resetAnalyticsData() {
    console.log('[Analytics] Reset analytics data');
    return Promise.resolve();
  }
}

// Exportamos la implementación de polyfill para el módulo @react-native-firebase/analytics
const analyticsModule = () => {
  return {
    setAnalyticsCollectionEnabled: (enabled) => Promise.resolve(),
    getAppInstanceId: () => Promise.resolve('web-app-instance-id'),
    logEvent: (eventName, params) => Promise.resolve(),
    setUserId: (userId) => Promise.resolve(),
    setUserProperty: (name, value) => Promise.resolve(),
    logScreenView: (params) => Promise.resolve(),
    setConsent: (settings) => Promise.resolve(),
    resetAnalyticsData: () => Promise.resolve(),
  };
};

// Instancia del servicio de Analytics para exportación
const analyticsService = new AnalyticsService();

// Exportamos versión default para import analytics from '@react-native-firebase/analytics'
analyticsModule.default = analyticsModule;

// Exportamos módulos para usar en Firebase.js
module.exports = {
  // Para importación directa
  default: analyticsModule,
  // Para import { analytics } from '@react-native-firebase/app'
  analytics: analyticsModule,
  // Para exportar en firebase.ts
  analyticsService
}; 